import endpoints from '../../../constants/configs/endpoints';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES } from '../../../constants/actionTypes/adminSerffStatusActionTypes';
import { api } from '../../../modules/common-utils-services/axiosUtil';

export const setPlanLoadStatusDataList = (data) => ({
    type: ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES.SET_PLAN_LOAD_STATUS_DATA,
    payload: data,
});

export const setAdminSerffIssuersOptions = (data) => {
    return {
    	type: ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES.SET_FILTER_OPTIONS,
    	payload: data,
    };
};

const actions = { setError, startSpinner, stopSpinner };

/**
 * Fetch Plan Load Status Data List with optional filters
 * @param filters - Optional filters object containing selectedIssuer, selectedType, selectedStatus, and dateRange
 */
export const fetchSerffPlanLoadStatusDataList = (filters) => async dispatch => {
    const {
        issuerFilter,
        typeFilter,
        statusFilter,
        dateFilter,
        page,
        size
    } = filters || {};

    const url = endpoints.ADMIN_SERFF_GET_PLAN_LOAD_STATUS_DATA_LIST.processReplacements({
        issuerFilter: issuerFilter,
        typeFilter: typeFilter,
        statusFilter:   statusFilter,
        dateFilter: dateFilter,
        page: page,
        size: size
    });

    try {
        const { data } = await api.get(url);

        if (!data) {
            console.warn('⚠️ No data returned for SERFF Plan Load Status request');
            return;
        } 
        dispatch(setPlanLoadStatusDataList(data));
    } catch (error) {
        console.error('Error fetching Plan Load Status Data:', error);
    } 
};